import { useMemo } from "react";
import ReactMarkdown from "react-markdown";
// import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
// import { oneDark as dark } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkGfm from "remark-gfm";

const MarkdownFormat = ({ children, isAdvance = false }) => {
  const plugins = useMemo(() => {
    if (!isAdvance) return [];
    return [remarkGfm];
  }, []);

  return (
    <ReactMarkdown
      remarkPlugins={plugins}
      components={{
        a: (props) => (
          <a
            {...props}
            rel="noopener noreferrer"
            target="_blank"
            className="text-red-500 underline"
          />
        ),
        // code: ({ inline, className, children, ...props }) => {
        //   const match = /language-(\w+)/.exec(className || "");

        //   return !inline && match ? (
        //     <SyntaxHighlighter
        //       style={dark}
        //       language={match[1]}
        //       PreTag="div"
        //       {...props}
        //     >
        //       {/* @ts-ignore */}
        //       {children.length > 0 && children[0].replace(/\n$/, "")}
        //     </SyntaxHighlighter>
        //   ) : (
        //     <code className={className} {...props}>
        //       {children}
        //     </code>
        //   );
        // },
      }}
    >
      {children}
    </ReactMarkdown>
  );
};

export default MarkdownFormat;
